import Vue from 'vue'
import store from '@vuex'
import {mapGetters} from 'vuex'
import {vuexTypes} from '@vuex/types'

import {i18n} from '@js/i18n'
import {ErrorFactory} from '@js/errors/factory'
import {factorsService} from '@api/factors.service'
import {EventDispatcher} from '@js/events/event_dispatcher'

import FlowBlockingModalMixin from './flow-blocking-modal.mixin'

const template = `
    <md-dialog :md-fullscreen="false" :md-active.sync="isOpened">    
      <md-dialog-title>
        {{ isLoggedIn ? i18n.mod_confirm_seed() : i18n.mod_confirm_seed_login() }}
      </md-dialog-title>

      <form novalidate @submit.prevent="onSubmit">
        <div class="app__dialog-inner">
          <input-field type="password"
                       id="seed"
                       name="seed"
                       :autofocus="true"
                       v-model="form.seed"
                       v-validate="validations.seed"
                       :disabled="isPending"
                       :label="i18n.lbl_validate_seed()"
                       :errorMessage="errorMessage('seed')"
          />
        </div>

        <md-dialog-actions>
          <md-button type="submit" class="md-primary" :disabled="isPending">
            {{ i18n.lbl_submit() }}
          </md-button>
        </md-dialog-actions>
      </form>
    </md-dialog>
 `

export function createTfaRecoveryDialog (callbackCollection, {walletId}) {
  const tfaRecoveryModal = document.createElement('div')
  document.querySelector('#app').appendChild(tfaRecoveryModal)

  return new Promise((resolve, reject) => {
    const tfaRecoveryDialog = new Vue({
      template,
      store,
      mixins: [FlowBlockingModalMixin],
      data () {
        return {
          i18n,
          form: {
            seed: ''
          },
          validations: {
            seed: 'required'
          }
        }
      },
      created () {
        this.setResolvers(resolve, reject)
      },
      computed: {
        ...mapGetters([
          vuexTypes.isLoggedIn
        ])
      },
      methods: {
        async onSubmit () {
          if (!await this.isValid()) return
          this.disable()

          try {
            await factorsService.resetFactor(walletId, this.form.seed)
            EventDispatcher.dispatchShowSuccessEvent(i18n.tfa_recovery_unblocked())
          } catch (error) {
            EventDispatcher.dispatchShowErrorEvent(i18n.unexpected_error())
            this.enable()
            return
          }

          this.resetResolvers()
          this.removeElement()

          if (callbackCollection && callbackCollection.length > 0) {
            try {
              callbackCollection.forEach((callback) => {
                this.resolvers.resolve(callback())
              })
            } catch (error) {
              return this.resolvers.reject(error)
            }
          } else {
            this.resolvers.resolve(true)
          }
        }
      },
      watch: {
        isOpened (val) {
          if (!val) {
            if (!this.isResolved) {
              this.resolvers.reject(ErrorFactory.getOTPCancelledError())
            }
            this.removeElement()
          }
        }
      }
    })
    tfaRecoveryDialog.$mount(tfaRecoveryModal)
  })
}



// WEBPACK FOOTER //
// ./src/js/modals/tfa_recovery.modal.js